import { List } from 'immutable';
import { convertibleValuationConstants } from '../constants';

export function convertible_valuations(state = {}, action) {
  switch (action.type) {
    case convertibleValuationConstants.CONVERTIBLE_VALUATION_LIST_LOADING:
      return {
        ...state,
        items: null,
        listLoading: true
      };
    case convertibleValuationConstants.CONVERTIBLE_VALUATION_LIST_SUCCESS:
      return {
        ...state,
        items: List(action.response),
        listLoading: false
      };
    case convertibleValuationConstants.CONVERTIBLE_VALUATION_LIST_FAILURE:
      return {
        ...state,
        listLoading: false,
        items: null,
        listError: action.error
      };
    case convertibleValuationConstants.CONVERTIBLE_VALUATION_CREATE_LOADING:
      return {
        ...state,
        createLoading: true
      };
    case convertibleValuationConstants.CONVERTIBLE_VALUATION_CREATE_SUCCESS: {
      const items = state.items ? state.items : List();
      return {
        ...state,
        items: items.push(action.response),
        createLoading: false,
        createError: null
      };
    }
    case convertibleValuationConstants.CONVERTIBLE_VALUATION_CREATE_FAILURE:
      return {
        ...state,
        createLoading: false,
        createError: action.error
      };

    case convertibleValuationConstants.CONVERTIBLE_VALUATION_EDIT_LOADING:
      return {
        ...state,
        editLoading: true
      };
    case convertibleValuationConstants.CONVERTIBLE_VALUATION_EDIT_SUCCESS: {
      if (!state.items) {
        return state;
      }

      const convertibleValuationIndex = state.items.findIndex(val => val.id == action.response.id);

      if (convertibleValuationIndex == -1) {
        return state;
      }

      return {
        ...state,
        items: state.items.set(convertibleValuationIndex, action.response),
        editLoading: false,
        editError: null
      };
    }
    case convertibleValuationConstants.CONVERTIBLE_VALUATION_EDIT_FAILURE:
      return {
        ...state,
        editLoading: false,
        editError: action.error
      };

    case convertibleValuationConstants.CONVERTIBLE_VALUATION_DELETE_LOADING:
      return {
        ...state,
        deleteLoading: true
      };
    case convertibleValuationConstants.CONVERTIBLE_VALUATION_DELETE_SUCCESS: {
      const { convertibleValuationId } = action;

      if (!state.items) {
        return state;
      }

      const convertibleValuationIndex = state.items.findIndex(
        val => val.id == convertibleValuationId
      );

      if (convertibleValuationIndex == -1) {
        return state;
      }

      return {
        ...state,
        items: state.items.delete(convertibleValuationIndex),
        deleteLoading: false,
        deleteError: null
      };
    }
    case convertibleValuationConstants.CONVERTIBLE_VALUATION_DELETE_FAILURE:
      return {
        ...state,
        deleteLoading: false,
        deleteError: action.error
      };
    case convertibleValuationConstants.CONVERTIBLE_VALUATION_ERROR_RELOAD:
      return {
        ...state,
        createError: null,
        editError: null
      };

    default:
      return state;
  }
}
